import React from 'react';
import { App } from 'antd';

interface AppProviderProps {
  children: React.ReactNode;
}

function AppProvider({ children }: AppProviderProps) {
  return <App>{children}</App>;
}

export { AppProvider };
